


import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

export default {
directives: {
TransferDom
},

components: { Popup },
props: {
isScenicPopShow: {
type: Boolean,
default: function() {
return false;
}
},
scenicPopData: {
type: Object,
default: function() {
return {};
}
},
isShowMask: {
type: Boolean,
default: function() {
return true;
}
}
},
data() {

return {
isShow: false,
audioSrc: "",
duration: "00:00", //音频剩余时间
playing: false 
};
},

computed: {},

watch: {
isScenicPopShow(newV, oldV) {
let that = this;
this.isShow = newV;
if (newV) {
if (this.scenicPopData.audio != null) {
let audio = document.getElementById("spAudio");
this.audioSrc =
this.GLOBAL.DOMAIN_URL +
this.scenicPopData.audio.split(".")[0] +
".mp3";
audio.load();

audio.addEventListener("canplay", function() {
that.duration = that.commonFun.transTime(audio.duration);
});
}
} else {
let audio = document.getElementById("spAudio");
if (audio.play) {
document.getElementById("spAudio").pause();
this.playing = false;
}
}
},
scenicPopData(newV) {
let that = this;
if (this.scenicPopData.audio != null) {
this.playing = false;
let audio = document.getElementById("spAudio");
this.audioSrc =
this.GLOBAL.DOMAIN_URL +
this.scenicPopData.audio.split(".")[0] +
".mp3";
audio.load();

audio.addEventListener("canplay", function() {
that.duration = that.commonFun.transTime(audio.duration);
});
}
},

isShow(newV, oldV) {
this.$emit("changeScenicPopShow", newV);
}
},

methods: {

location() {
this.commonFun.openLocation(
this.scenicPopData.name,
sessionStorage.getItem("lat"),
sessionStorage.getItem("lng"),
this.scenicPopData.latitude_gcj,
this.scenicPopData.longitude_gcj
);
},
jumpToMap() {
this.$router.push({
path: "/map",
name: "map",
query: { hid: this.scenicPopData.id }
});
},

audioPlay() {
let that = this;
let audio = document.getElementById("spAudio");

audio.addEventListener(
"timeupdate",
function() {
that.updateProgress(audio);
},
false
);


audio.addEventListener(
"ended",
function() {
that.audioEnded(audio);
},
false
);


if (audio.paused) {

audio.play();
that.playing = true;
} else {
audio.pause();
that.playing = false;
}
},

updateProgress(audio) {

this.duration = this.commonFun.transTime(
audio.duration - audio.currentTime
);
},

audioEnded(audio) {
this.playing = false;
this.duration = this.commonFun.transTime(audio.duration);
},
openDetailPop() {
console.log(this.scenicPopData);
let that = this;
that.$emit("getScenicDetail", that.scenicPopData);









}
},

created() {},

mounted() {},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};



// WEBPACK FOOTER //
// ./src/components/scenicPop.vue